<template>
    <span 
        v-if="mostrarIcone"
    >
        <span class="text-warning ml-1">
            <i
                class="fa fa-info-circle fa-lg icon-button"
                title="Justificativa de anexo duplicado"
                @click.stop="mostrarJustificativa()"
            ></i>
        </span>
        <b-modal
            v-model="mostrarModalJustificativa"
        >
            <div slot="modal-title">Justificativa para anexo duplicado</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Mensagem</label>
                        <b-form-textarea
                            v-model="anexo.justificativaAnexoDuplicado"
                            :rows="4"
                            :disabled="true"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharJustificativa()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </span>
</template>

<script>
export default {
    props: {
        anexo: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            mostrarModalJustificativa: false,
        }
    },

    methods: {
        mostrarJustificativa() {
            this.mostrarModalJustificativa = true
        },

        fecharJustificativa() {
            this.mostrarModalJustificativa = false
        }
    },

    computed: {
        mostrarIcone() {
            return (
                this.anexo.justificativaAnexoDuplicado != null
            )
        },
    }
}
</script>
